import React, { useState, useEffect, Fragment } from "react";
import styles from "./styles.module.css";
import Head from "next/head";

import TagManager from "react-gtm-module";
import getDataLayer from "@/shared/functions/gtm";
import getFormatedDate from "../Nota/components/functions/getFormatedDate";
import LdJsonVideo from './components/Ldjson';

import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import Chartbeat from '@/shared/components/Chartbeat';

import Author from "../Nota/components/Author";
import Nameplate from "../Nota/components/Nameplate";
import SocialLinks from '../Nota/components/Social/index.js';
import DataFactory from "../Nota/components/DataFactory";

import Templates from '@/widgets/index';
import MegaBannerDerecha from '@/shared/components/MegaBannerDerecha'
import { getImage, getImageFromClippingList } from "@/shared/functions/getImagesFunctions";
import JWPlayer from "@/shared/components/JWPlayer/index.js";
import PagegrowlerList from "@/widgets/Listado/Templates/PagegrowlerList";

function Video(props) {
    const [components, setComponents] = useState()
    const [isClient, setIsClient] = useState(false)

    const CONTENT_CLIPPING = "3_2_870x580";

    const [open, setOpen] = useState(false);

    let menues = props.menu ? props.menu : [];

    const {
        _id,
        summary,
        authors,
        publishedDate,
        modificatedAt,
        related,
        sections,
        gtm_name,
        url,
        tags,
        subtitle,
        metadata,
        videoFiles,
        description,
        thumbnail,
        name,
        keywords,
        entityId,
        duration
    } = { ...props.content };

    const relatedNews = props.content && props.content.related ? props.content.related.lilanews : [];
    const relatedDataFactory = props.content && props.content.related && props.content.related.datafactory ? props.content.related.datafactory : [];
    const typeDatafactory = { domain: process.env.NEXT_PUBLIC_DATAFACTORY_IFRAME_URL };
    const metaAuthor = authors && authors.length > 0 ? authors[0].name : 'Ellitoral.com';

    const gtmObject = {
        _id: _id,
        publishedDate: publishedDate,
        page_type: "Video",
        nsSite:
            sections !== undefined && sections.length > 0
                ? sections[0].nsSite
                : "",
        gtm_name: gtm_name,
    };

    useEffect(() => {
        setIsClient(true)
        TagManager.dataLayer({ dataLayer: getDataLayer(gtmObject) });
        let textQuote = document.querySelector('.article .custom-text blockquote');

        if (textQuote) {
            let lastLetterQuote = textQuote.innerHTML.length - 1;
            textQuote.innerHTML = textQuote.innerHTML.slice(0, 2)
                + '<span>' +
                textQuote.innerHTML.slice(2, -1)
                + '</span>' +
                textQuote.innerHTML[lastLetterQuote];
        }
    }, []);

    const { hour: modificatedAtHour, minutes: modificatedAtMinutes } =
        getFormatedDate(modificatedAt);

    const {
        day: publishedDay,
        weekday: publishedWeekday,
        month: publishedMonth,
        year: publishedYear,
    } = getFormatedDate(publishedDate);

    const publishedMonthDayYear = `${publishedWeekday} ${publishedDay}.${publishedMonth}.${publishedYear}`;
    const lastUpdateDates = `${modificatedAtHour}:${modificatedAtMinutes}`;

    const [temasPosition, setTemasPosition] = useState(-1);

    const tagTemasArrayLength = tags.length;
    const minimumTemasItems = tagTemasArrayLength - 6;
    let sectionUrl = url.split('/');
    sectionUrl.pop();
    sectionUrl = "/seccion" + sectionUrl.join('/');
    let summaryWithoutHtml = description ? description.replace(/(<([^>]+)>)/gi, "") : '';
    const keywordsContent = keywords || (tags && tags.length > 0 ? tags.map(t => t.name).join(', ') : '');
    let relatedImages = (related && related.images && related.images[0].value) ? getImageFromClippingList(related.images[0].value.clippings, CONTENT_CLIPPING) : { domain: '', imgUrl: '' };
    let thumnbnailLarge = thumbnail ? thumbnail.replace("?width=320", "?width=1280") : '';

    const handleStyles = (index) => {
        if (index <= temasPosition && index <= minimumTemasItems) {
            return `${styles['temas-hidden']}`;
        } else {
            return `${styles['temas-text']}`;
        }
    };

    return (
        <>
            <Head>
                <title>[Video] {name}</title>
                <meta name="author" content={metaAuthor} />
                <meta name="distribution" content="global" />
                <meta name="robots" content="max-image-preview:large" />
                <meta name="title" content={`[Video] ${name}`} />
                <meta name="description" content={summaryWithoutHtml} />
                {keywordsContent && <meta name="keywords" content={keywordsContent} />}
                {keywordsContent && <meta name="news_keywords" content={keywordsContent} />}

                {/* Open Graph */}
                <meta property="og:type" content="video.other" />
                <meta property="og:site_name" content="El Litoral" />
                <meta property="og:locale" content="es_AR" />
                <meta property="og:url" content={process.env.NEXT_PUBLIC_DOMAIN_URL + url} />
                <meta property="og:title" content={`[Video] ${name}`} />
                <meta property="og:description" content={summaryWithoutHtml} />
                <meta property="og:image" content={thumnbnailLarge} />
                <meta property="og:image:width" content="1280" />
                <meta property="og:image:height" content="720" />
                {videoFiles?.mp4 && <meta property="og:video" content={videoFiles.mp4} />}
                {videoFiles?.mp4 && <meta property="og:video:secure_url" content={videoFiles.mp4} />}
                {videoFiles?.mp4 && <meta property="og:video:type" content="video/mp4" />}
                {videoFiles?.m3u8 && <meta property="og:video:url" content={videoFiles.m3u8} />}

                {/* Article dates */}
                {publishedDate && <meta property="article:published_time" content={publishedDate} />}
                {modificatedAt && <meta property="article:modified_time" content={modificatedAt} />}
                {sections && sections[0] && <meta property="article:section" content={sections[0].name} />}

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@ellitoral" />
                <meta name="twitter:creator" content="@ellitoral" />
                <meta name="twitter:title" content={`[Video] ${name}`} />
                <meta name="twitter:description" content={summaryWithoutHtml} />
                <meta name="twitter:image" content={thumnbnailLarge} />

                {thumbnail && <link rel="preload" href={thumbnail} as="image" fetchpriority="high" />}
                <link rel="image_src" href={thumnbnailLarge} />
                <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + url} />
            </Head>
            <LdJsonVideo
                content={props.content}
                url={process.env.NEXT_PUBLIC_DOMAIN_URL + url}
                summary={summaryWithoutHtml}
                thumbnailUrl={thumnbnailLarge}
                authors={authors}
                sections={sections}
                sectionUrl={sectionUrl}
            />
            <Chartbeat sections={sections} authors={authors} />
            <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
            <div className={`${styles["parent"]}`}>
                <div className={`${styles['main-container']}`}>


                    {!props.preview && <Templates.BannerHorizontalChico bannerId={`top`} />}




                    <div id="fb-root" style={{ display: "none" }} />
                    <div className={"article"}>
                        <hr className={`${styles["article-container-hr"]}`} />
                        <div className={`${styles["article-container-title"]}`}>
                            <Nameplate sections={sections} subtitle={subtitle} title={name} summary={description} sectionUrl={sectionUrl} />

                            <hr />

                            <div className={`${styles["grid-container"]}`}>
                                <div className={`${styles["detail-left"]}`}>
                                    <div id={`cuerpo-de-nota`} className={`${styles['dynamic-content']}`}>
                                        {metadata && metadata.sponsored && (
                                            <div className={`${styles["sponsored-content"]}`}>
                                                <h3>contenido <strong>patrocinado</strong></h3>
                                            </div>
                                        )}
                                        {isClient && (
                                            <div className={`${styles["dates-container"]} ${styles["paragraph-detail"]}`}>
                                                <div>{publishedMonthDayYear}</div>

                                                <span className={`${styles['separator']}`}>-</span>

                                                <div className={`${styles['time-update']}`}>
                                                    Última actualización -
                                                    <span>&#160;{lastUpdateDates}</span>
                                                </div>
                                            </div>
                                        )}


                                        {/* Social links */}
                                        <div className={`${styles["paragraph-detail"]}`}>
                                            <SocialLinks url={url} />
                                        </div>

                                        {/* Autores */}
                                        {authors && (
                                            <div className={`${styles["author-container"]} ${styles["paragraph-detail"]}`}>
                                                <div className={`${styles["author-box-container"]}`}>
                                                    {authors.map((author, index) => (
                                                        <Fragment key={'author' + index}>
                                                            <Author author={author} />
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div style={{ margin: '1rem 0px 0px 0px' }} className={`${styles["paragraph-detail"]}`}>
                                            <JWPlayer playerId={videoFiles._id} thumbnail={thumbnail} file={videoFiles.m3u8} playerScript="https://cdn.jwplayer.com/libraries/ogkm6Oc3.js" />
                                        </div>

                                        {relatedDataFactory && relatedDataFactory[0] && relatedDataFactory[0].type && <div>
                                            <DataFactory content={relatedDataFactory[0].value} type={typeDatafactory} />
                                        </div>}


                                    </div>

                                    {/* Social links */}
                                    <div className={`${styles['social-mobile']}`}>
                                        <SocialLinks url={url} />
                                    </div>
                                    {/* carrousel videos */}
                                    <div className={`${styles['cont-carru']}`}>
                                        <PagegrowlerList widget='CarouselDeVideos' url='top-video' fallbackUrl='top-lilanews' isMobile={false} />
                                        <PagegrowlerList widget='CarouselDeVideos' url='top-video' fallbackUrl='top-lilanews' isMobile={true} />
                                    </div>

                                    {tags && tags.length > 0 && (
                                        <>
                                            <div className={`${styles['temas-container']}`}>
                                                <div className={`${styles['temas-title']}`}>
                                                    #TEMAS:
                                                </div>
                                                <div className={`${styles['temas-tags']}`}>
                                                    {tags.map((element, index) => (
                                                        <div
                                                            key={'tags' + index}
                                                            className={handleStyles(index)}
                                                        >
                                                            <a href={`/tags/${element.slug}`}>{element.name}</a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {/* otros Videos listado */}
                                    <div className={`${styles["detail-full"]} tags-list`}>
                                        <PagegrowlerList widget='TePuedeInteresar' url='bottom-videos' />
                                    </div>

                                    {
                                        relatedNews && relatedNews.length > 0 && (
                                            <div className={`${styles['related-news-container']}`}>
                                                <div className={`${styles['related-news-title']}`}>
                                                    Además tenes que leer:
                                                </div>
                                                {relatedNews.map(({ value, _id }) => {
                                                    if (value && value.url) {
                                                        const { url = '', title, shortTitle = '' } = value;

                                                        let img = pagegrowlerFunctions.getFullImageObject(value.related, '3_2_230x153', process.env.NEXT_PUBLIC_IMAGE_DOMAIN);
                                                        const { url: src, title: alt, width, height } = img;

                                                        return (
                                                            <a href={url} className={`${styles['related-news-content']}`} key={_id}>
                                                                <img src={src} alt={alt} width={width} height={height} loading='lazy' />
                                                                <div className={`${styles['related-news-content-title']}`}>
                                                                    {title}
                                                                </div>
                                                            </a>
                                                        )
                                                    }
                                                })}
                                            </div>
                                        )
                                    }


                                </div>

                                <div className={`${styles["detail-right"]}`}>
                                    <PagegrowlerList url='column-video' fallbackUrl="column-lilanews" />
                                </div>

                            </div>
                            <div className={`${styles["detail-full"]} tags-list`}>
                                {!props.preview && <Templates.BannerHorizontalChico bannerId={`horizontal1`} />}
                                <br />
                                {!props.preview && <Templates.BannerHorizontalGrande bannerId={`horizontal2`} />}
                                <PagegrowlerList widget='TePuedeInteresar' url='bottom-gallery' fallbackUrl='bottom-lilanews' />
                            </div>
                            <div className={`${styles["detail-full"]} tags-list`}>
                                <PagegrowlerList
                                    widget="SeccionGalerias"
                                    url="top-gallery"
                                    fallbackUrl="top-lilanews"
                                    overrideProps={{ title: "Galerías de imágenes", link: "/fotos-hd" }}
                                />
                            </div>
                            <div className={`${styles["detail-full"]} tags-list`}>
                                <PagegrowlerList
                                    widget="SeccionVideos"
                                    url="top-video"
                                    fallbackUrl="top-lilanews"
                                    overrideProps={{ title: "Otros Videos", link: "/videos" }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`${styles["parent-right"]}`} />
                </div>
            </div>
            <div style={{ clear: "both" }}>
                <Footer />
                {!props.preview && <MegaBannerDerecha customId={`lateralmega`} />}
            </div>
        </>
    );
}

export default Video;
